<div class="flex-row fixed-top">
    <div style="height: 70px;">
        <cfa-navigation-wrapper
            [appName]="appName"
            [ignoreContainerPadding]="true"
            [shortAppName]="shortName"
            [showDropShadow]="true"
            [userName]="userName$ | async"
            (signout)="signOut()"
        >
            <cfa-tab
            *ngFor="let tab of tabs"
            [disabled]="tab.isDisabled"
            [label]="tab.label"
            [routerLink]="tab.url"
        >
        </cfa-tab>
    </cfa-navigation-wrapper>
    </div>
</div>
<div class="page-content">
        <router-outlet></router-outlet>
</div>
<div class="fixed-bottom">
    <div style="height: 30px">
        <emm-app-info [uiVersion]="version"></emm-app-info>
    </div>
</div>
